import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initTabCoordinator, requestFocus } from './lib/tabCoordinator';

// Start cross-tab coordination (the listener is active in every tab).
// If BroadcastChannel is unsupported, this is a safe no-op.
initTabCoordinator();

// If this tab was opened by a native notification (marked with focus=1), ask
// an already-open tab on the same bport to focus itself. If a matching tab
// answers, close this duplicate tab. The app always renders regardless, so a
// blocked window.close() never leaves a blank page.
try {
  const params = new URLSearchParams(window.location.search);
  if (params.get('focus') === '1') {
    const rawBport = params.get('bport');
    const port = rawBport ? parseInt(rawBport, 10) : NaN;

    // Strip the marker so a manual refresh does not re-trigger this flow.
    params.delete('focus');
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname +
      (newSearch ? `?${newSearch}` : '') +
      window.location.hash;
    window.history.replaceState({}, '', newUrl);

    if (!isNaN(port)) {
      requestFocus(port).then((matched) => {
        if (matched) {
          // A tab on this bport is now focused; remove this duplicate.
          try {
            window.close();
          } catch {
            // window.close can be blocked by the browser; the app already
            // rendered, so the user still has a working tab.
          }
        }
      });
    }
  }
} catch {
  // Best-effort; never block app startup.
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);